import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { Button } from './ui/Button';
import { copyToClipboard } from '@/utils/clipboard';

interface CopyButtonProps {
  textToCopy: string;
  className?: string;
}

export function CopyButton({ textToCopy, className }: CopyButtonProps): React.ReactElement {
  const [copied, setCopied] = useState(false);

  function handleCopy(e: React.MouseEvent): void {
    e.stopPropagation();
    copyToClipboard(textToCopy);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  return (
    <Button
      variant={copied ? 'success' : 'secondary'}
      size="xs"
      onClick={handleCopy}
      leftIcon={copied ? <Check size={14} /> : <Copy size={14} />}
      className={className}
    >
      {copied ? 'Copied' : 'Copy'}
    </Button>
  );
}
